<!-- <ngx-spinner bdColor="rgba(0, 0, 0, 0.8)" size="medium" color="#fff" type="ball-grid-beat" [fullScreen]="true">
  <p style="color: white">Please Wait...</p>
</ngx-spinner> -->

<div class="header_second">
  <div class="Dashboard_head">
    <div class="page-heading">
      <span class="page-title">Registrations ({{this.totalCount}})</span>

      <span *ngIf="selection.selected.length > 0" class="selection-count">
        {{ selection.selected.length }} selected
      </span>
    </div>

    <div class="header-actions">
      <!-- Primary Action -->
      <button mat-raised-button color="primary" (click)="addReg()">
        <mat-icon>person_add</mat-icon>
        New Registration
      </button>

      <!-- ID Card Actions -->
      <button mat-stroked-button color="primary" [matMenuTriggerFor]="idCardMenu"
        [matTooltip]="'Passes Remaining: ' + passNotExists + ' ' + '/' + ' ' + this.totalCount + '\nPending to Send: ' + noCount +' ' + '/' + ' ' + totalCount">
        <mat-icon>badge</mat-icon>
        ID Cards
      </button>

      <mat-menu #idCardMenu="matMenu">
        <button mat-menu-item (click)="Create_Remaining_Card()">
          <mat-icon>autorenew</mat-icon>
          Generate Pending ({{passNotExists}})
        </button>

        <button mat-menu-item (click)="Create_All_Card()">
          <mat-icon>download</mat-icon>
          Regenerate All & Download
        </button>

        <mat-divider></mat-divider>

        <button mat-menu-item (click)="Send_Pending_Card()">
          <mat-icon>schedule</mat-icon>
          Send Pending ({{noCount}})
        </button>

        <button mat-menu-item (click)="Send_All()">
          <mat-icon>send</mat-icon>
          Send All
        </button>
      </mat-menu>

      <!-- Reports -->
      <!-- <button mat-stroked-button (click)="Reports()">
        <mat-icon>bar_chart</mat-icon>
        Reports
      </button> -->

      <span class="action-divider"></span>
      <mat-form-field appearance="outline" class="scan-field" subscriptSizing="dynamic">
        <mat-label>Scanning Point</mat-label>
        <mat-select [(ngModel)]="point">
          <mat-option *ngFor="let data of scanning_data" [value]="data.point">
            {{ data.point }}
          </mat-option>
        </mat-select>
      </mat-form-field>

      <!-- Bulk Actions -->
      <button mat-raised-button color="accent" (click)="bulkCheckIn()" [disabled]="selection.selected.length === 0">
        <mat-icon>login</mat-icon>
        Check-In
      </button>

      <button mat-raised-button color="warn" (click)="bulkCheckOut()" [disabled]="selection.selected.length === 0">
        <mat-icon>logout</mat-icon>
        Check-Out
      </button>
    </div>
  </div>
</div>

<div *ngIf="progressState?.isProcessing" class="progress-container">

  <mat-progress-bar mode="determinate" [value]="progressState.progress">
  </mat-progress-bar>

  <div class="progress-text">
    {{ progressState.success }} / {{ progressState.total }} Sent
    ({{ progressState.progress }}%)
  </div>

</div>

<div class="progress-container" *ngIf="isProcessing">
  <div class="progress-header">
    <span>Processing Cards</span>
    <span>{{ progress }}%</span>
  </div>

  <div class="progress-bar">
    <div class="progress-fill" [style.width]="progress + '%'"></div>
  </div>

  <div class="progress-stats">
    <span>Processed: {{ processed }}</span>
    <span>Skipped: {{ skipped }}</span>
    <span>Remaining: {{ remaining }}</span>
  </div>
</div>

<!-- <div class="row d-flex justify-content-between align-items-center" style="margin: 0.5rem;">
    <div class="whatsapp-card col-xl-3 col-lg-3 col-md-3 col-sm-3 col-6">
        <p class="m-0">WhatsApp ID Card </p>
        <span class="text-success"> Sent : {{yesCount}} </span>&nbsp;
        <span class="text-danger"> Pending : {{noCount}} </span>
    </div>
    <div style="text-align: end;" class="col-xl-6 col-lg-9 col-md-9 col-sm-9 col-6 p-0">
        <button class="me-2" [matMenuTriggerFor]="create_image" style="color: green;" mat-stroked-button>Create
            Images</button>
        <mat-menu #create_image="matMenu">
            <button mat-menu-item class="me-2" (click)="Create_Remaining_Card()">Create Remaining</button>
            <button mat-menu-item class="me-2" (click)="Create_All_Card()">Create All</button>
        </mat-menu>

        <button class="me-2" [matMenuTriggerFor]="menu" style="color: rgb(255, 0, 0);" mat-stroked-button>Send ID
            Card</button>
        <mat-menu #menu="matMenu">
            <button mat-menu-item class="me-2" (click)="Send_Pending_Card()">Send Pending</button>
            <button mat-menu-item class="me-2" (click)="Send_All()">Send All</button>
        </mat-menu>
        <button mat-stroked-button color="primary" (click)="Reports()">Report</button>
    </div>
</div> -->

<div class="mat-elevation-z8 registration-table-card">
  <div class="table-toolbar">
    <!-- Row 1 -->
    <div class="toolbar-row top-row">
      <mat-form-field appearance="outline" class="toolbar-search" subscriptSizing="dynamic">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilter($event)" />
      </mat-form-field>

      <!-- <mat-form-field appearance="outline" class="scan-field" subscriptSizing="dynamic">
        <mat-label>Scanning Point</mat-label>
        <mat-select [(ngModel)]="point">
          <mat-option *ngFor="let data of scanning_data" [value]="data.point">
            {{ data.point }}
          </mat-option>
        </mat-select>
      </mat-form-field> -->
    </div>

    <!-- Row 2 -->
    <div class="toolbar-row bottom-row">
      <input type="file" hidden #filee (change)="mainupload(filee.files)" />

      <button mat-stroked-button (click)="filee.click()">
        <mat-icon>upload</mat-icon>
        Import
      </button>

      <button mat-stroked-button [matMenuTriggerFor]="export">
        <mat-icon>download</mat-icon>
        Export
      </button>

      <mat-menu #export="matMenu">
        <button mat-menu-item (click)="exportTable('all', 'no')">
          Export Registrations
        </button>
        <button mat-menu-item (click)="exportTable('all', 'yes')">
          Export Dummy
        </button>
      </mat-menu>
    </div>
  </div>

  <div class="table-responsive">
    <mat-progress-bar *ngIf="loading" mode="indeterminate"></mat-progress-bar>
    <table mat-table [dataSource]="dataSource" matSort recycleRows class="registration-table">
      <ng-container matColumnDef="select" sticky>
        <th mat-header-cell *matHeaderCellDef>
          <!-- <mat-checkbox (change)="$event ? toggleAllRows() : null" [checked]="selection.hasValue() && isAllSelected()"
            [indeterminate]="selection.hasValue() && !isAllSelected()" [aria-label]="checkboxLabel()">
          </mat-checkbox> -->
        </th>
        <td mat-cell *matCellDef="let row">
          <mat-checkbox (click)="$event.stopPropagation()" (change)="$event ? selection.toggle(row) : null"
            [checked]="selection.isSelected(row)" [aria-label]="checkboxLabel(row)">
          </mat-checkbox>
        </td>
      </ng-container>
      <!-- Position Column -->
      <ng-container matColumnDef="mem_id" sticky>
        <th mat-header-cell *matHeaderCellDef mat-sort-header>No.</th>
        <td mat-cell *matCellDef="let element">
          <div class="record-id">
            {{ element.mem_id }}
            <mat-icon class="print" (click)="printCard(element.event_id, element.mem_id)">print</mat-icon>
            <mat-icon class="print" (click)="printTicket(element.event_id, element.mem_id)">
              local_activity</mat-icon>
          </div>
        </td>
      </ng-container>

      <ng-container matColumnDef="image" *ngIf="showImage">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Image</th>
        <td mat-cell *matCellDef="let element">
          <img src="{{ element.image }}" class="table-thumb" loading="lazy"
            onerror="this.src = `https://aieventzo.com/upload/default.png`" />
        </td>
      </ng-container>

      <ng-container matColumnDef="id_proof" *ngIf="showIdProof">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>ID Proof</th>
        <td mat-cell *matCellDef="let element">
          <img src="{{ element.id_proof }}" class="table-thumb" loading="lazy"
            onerror="this.src = `https://aieventzo.com/upload/default.png`" />
        </td>
      </ng-container>

      <ng-container matColumnDef="payment_ss" *ngIf="showPaymentSS">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Payment SS</th>
        <td mat-cell *matCellDef="let element">
          <img src="{{ element.payment_ss }}" class="table-thumb" loading="lazy"
            onerror="this.src = `https://aieventzo.com/upload/default.png`" />
        </td>
      </ng-container>

      <ng-container matColumnDef="allowed_person">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Quantity</th>
        <td mat-cell *matCellDef="let element">
          <mat-form-field appearance="outline" subscriptSizing="dynamic" class="Quantity_input">
            <input *ngIf="isEditable(element)" [(ngModel)]="element.allowed_person"
              (blur)="allowedPersonChange(element)" (keydown.enter)="allowedPersonChange(element)" matInput />
          </mat-form-field>
          <span *ngIf="!isEditable(element)">{{ element.allowed_person }}</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="barcode">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Barcode</th>
        <td mat-cell *matCellDef="let element">{{ element.barcode }}</td>
      </ng-container>

      <ng-container matColumnDef="payment_status">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Payment Status
        </th>
        <td mat-cell *matCellDef="let element">
          <span class="payment-chip" [ngClass]="getPaymentClass(element.payment_status)">
            {{ element.payment_status | titlecase }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="transaction_id">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Transaction ID
        </th>
        <td mat-cell *matCellDef="let element">{{ element.transaction_id }}</td>
      </ng-container>

      <ng-container matColumnDef="coupon_code">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Coupon Code</th>
        <td mat-cell *matCellDef="let element">{{ element.coupon_code }}</td>
      </ng-container>

      <ng-container matColumnDef="created_via">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Created Via</th>
        <td mat-cell *matCellDef="let element">{{ element.created_via }}</td>
      </ng-container>

      <ng-container matColumnDef="reg_date">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Register On</th>
        <td mat-cell *matCellDef="let element">
          {{
          getTime(element.reg_date, element.time) | date: "dd/MM/yyyy h:mm a"
          }}
        </td>
      </ng-container>

      <ng-container matColumnDef="tic_category">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          Ticket Category
        </th>

        <td mat-cell *matCellDef="let element">
          <span class="ellipsis" matTooltip="{{ element.category }}">
            {{ element.category }}
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="is_approved">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>Approved</th>

        <td mat-cell *matCellDef="let element">
          <mat-slide-toggle [ngModel]="element.is_approved" (ngModelChange)="onApprovalChange(element, $event)">
            <!-- {{ element.is_approved ? "Approved" : "Pending" }} -->
          </mat-slide-toggle>
        </td>
      </ng-container>

      <ng-container matColumnDef="check_status">
        <th mat-header-cell *matHeaderCellDef> Check-In ? </th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.is_checked_in == 'no'" class="payment-chip pay-failed">
            no
          </span>
          <span *ngIf="element.is_checked_in == 'yes'" class="payment-chip pay-captured">
            yes
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="send_whatsapp" stickyEnd>
        <th matTooltip="ID Card Status" mat-header-cell *matHeaderCellDef class="id-card-status-header">
          ID Card
          Pending: <span class="pending-count"> {{ noCount }} </span>
        </th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.whatsapp_status !== 'no'" class="payment-chip pay-captured">
            Sent
          </span>
          <button mat-raised-button [hidden]="element.whatsapp_status != 'no'" class="send-card-button"
            (click)="Send_Whatsapp(element)">
            Send
          </button>
          <button mat-icon-button color="primary" [hidden]="!element.wamid" mat-tooltip="Re-Check WhatsApp Status"
            (click)="checkWhatsappStatus(element.wamid, element.reg_id)">
            <mat-icon>refresh</mat-icon>
          </button>
        </td>
      </ng-container>

      <ng-container matColumnDef="action" stickyEnd>
        <th mat-header-cell *matHeaderCellDef>Action</th>

        <td mat-cell *matCellDef="let element">
          <div class="action-buttons">
            <!-- More Menu -->
            <button mat-icon-button color="primary" [matMenuTriggerFor]="add">
              <mat-icon>more_vert</mat-icon>
            </button>
          </div>

          <!-- Dropdown Menu -->
          <mat-menu #add="matMenu">
            <button mat-menu-item (click)="editReg(element.reg_id)">
              <mat-icon>edit</mat-icon>
              Edit
            </button>
            <button mat-menu-item color="warn" (click)="DeleteReport(element.reg_id)">
              <mat-icon>delete</mat-icon>
              Delete
            </button>
            <button mat-menu-item (click)="Assign_Ticket(element)">
              <mat-icon>assignment_ind</mat-icon>
              Assign Ticket
            </button>

            <!-- Cash Pay -->
            <button mat-menu-item (click)="CashPay(element.mem_id)">
              <mat-icon>payments</mat-icon>
              Cash Pay
            </button>
            <button mat-menu-item (click)="previewCard(element)">
              <mat-icon>visibility</mat-icon>
              Preview ID Card
            </button>
            <button mat-menu-item (click)="downloadCard(element, 'image')">
              <mat-icon>image</mat-icon>
              Download ID Card
            </button>
            <button mat-menu-item (click)="downloadCard(element, 'pdf')">
              <mat-icon>picture_as_pdf</mat-icon>
              Download ID Card PDF
            </button>
          </mat-menu>
        </td>
      </ng-container>

      <ng-container *ngFor="let col of regFieldColumns" [matColumnDef]="col">
        <th mat-header-cell *matHeaderCellDef mat-sort-header>
          {{ regFieldLabels[col] }}
        </th>

        <td mat-cell *matCellDef="let element">
          <span [ngClass]="{ 'ellipsis': col !== 'name' }" matTooltip="{{ element[col] }}">
            {{ element[col] }}
          </span>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns; sticky: true"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
    </table>
  </div>

  <mat-paginator [pageSizeOptions]="[100, 250, 500]" showFirstLastButtons aria-label="Select page of periodic elements">
  </mat-paginator>
</div>